import {Component, OnInit} from '@angular/core';
import {BaseComponent} from "../../../base.component";
import {IAd} from "../../../landing/landing.models";
import {Constants} from "../../../constants";
import {LoggerService} from "../../../common/logger.service";
import {LandingService} from "../../../landing/landing.service";
import {UserService} from "../../../common/user.service";
import {AnalyticsService} from "../../../analytics/analytics.service";
import {forkJoin, from, Observable, throwError} from "rxjs";
import {IShopUser} from "../../../session/customer-models";
import {AuthUtil} from "../../../auth/auth-util";
import {catchError, filter, map, switchMap, tap} from "rxjs/operators";
import {LocaleUtil} from "../../../util/locale-util";

@Component({
    selector: 'landing-ad-side-by-side',
    templateUrl: './landing-ad-side-by-side.component.html',
    styleUrls: ['./landing-ad-side-by-side.component.scss'],
    standalone: false
})
export class LandingAdSideBySideComponent extends BaseComponent implements OnInit {


    bottomLeftAd: IAd;
    bottomRightAd: IAd;
    isNfr: boolean = false;

    constructor(
        loggerService: LoggerService,
        private landingService: LandingService,
        private userService: UserService,
        private analyticsService: AnalyticsService,

    ) {
        super(userService, loggerService);
    }

    ngOnInit(): void {
        this.initAds().subscribe();
    }

    initAds(): Observable<any> {
        return from(this.userService.getShopUserPromise()).pipe(
            filter((user: IShopUser) => !AuthUtil.isNfr(user)),
            tap((user: IShopUser) => this.isNfr = AuthUtil.isNfr(user)),
            switchMap((user: IShopUser) => this.getAds(LocaleUtil.getTranslationLocale(user))),
            catchError((error: any) => throwError(error))
        );
    }

    getAds(usanaLocale: string): Observable<any> {
        const sources: Observable<any>[] = [];
        if (!this.eventShopping) {
            sources.push(this.landingService.getLandingAd(usanaLocale, Constants.AD_LANDING_BOTTOM_RIGHT));
            sources.push(this.landingService.getLandingAd(usanaLocale, Constants.AD_LANDING_BOTTOM_LEFT));
        }
        if (sources.length === 0) {
            return from([[]]).pipe(
                map(() => {
                    this.bottomRightAd = null;
                    this.bottomLeftAd = null;
                    return [this.bottomRightAd, this.bottomLeftAd];
                })
            );
        }
        return forkJoin(sources).pipe(
            map((results: any[]) => {
                const bottomRight = results[0];
                const bottomLeft = results[1];
                this.bottomRightAd = bottomRight ? bottomRight[0] : null;
                this.bottomLeftAd = bottomLeft ? bottomLeft[0] : null;
                this.analyticsService.adPromotionViewEvent([this.bottomRightAd, this.bottomLeftAd]);
                return [this.bottomRightAd, this.bottomLeftAd];
            }),
        );
    }

    sendAdPromotionClick(ad: IAd) {
        this.analyticsService.adPromotionClickEvent(ad);
    }

    showLowerAds(): boolean {
        return (!!this.bottomRightAd?.images || !!this.bottomLeftAd?.images) && !this.isNfr;
    }

}
